module.exports = __webpack_public_path__ + "img/1.219aa88e.png";